import { SurveysList } from './Components/SurveysList/SurveysList';

export const Surveys = () => <SurveysList />;
